import { Link } from 'react-router-dom';

export function MobileHeader({ isScrolled, onMenuOpen }) {
  return (
    <div className="flex md:hidden items-center justify-between h-20">
      <div className="flex items-center">
        <Link to="/" className="relative group">
          <span className="text-4xl font-bold">
            <span className="text-[#7C3AED]">A</span>
            <span className={isScrolled ? 'text-[#06B6D4]' : 'text-white'}>vision</span>
            <span
              className={`block text-[10px] font-medium tracking-wider uppercase -mt-0.5 ${
                isScrolled ? 'text-white/60' : 'text-white/60'
              }`}
            >
              Commercial & Specialty Lighting · South Florida
            </span>
          </span>
        </Link>
      </div>

      <div className="flex items-center">
        <button
          type="button"
          onClick={onMenuOpen}
          className={`
            relative group
            flex items-center justify-center
            w-12 h-12 rounded-full
            ${
              isScrolled
                ? 'bg-[#0F0F23]/80 border border-[#7C3AED]/30 text-white'
                : 'bg-white/10 border border-white/20 text-white'
            }
            focus:outline-none
            transition-colors duration-200
          `}
          aria-label="Open menu"
        >
          <i className="fas fa-bars text-xl group-hover:text-[#06B6D4] transition-colors" />
        </button>
      </div>
    </div>
  );
}
